function useCaptcha() {
  const captchaSolution = useState("captchaSolution", () => "");

  const {
    public: {
      friendlyCaptcha: { siteKey },
    },
  } = useRuntimeConfig();

  return { captchaSolution, siteKey };
}

export default createSharedComposable(useCaptcha);
